function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_22",
  "data-name": "Rectangle 22",
  width: 32,
  height: 24,
  fill: "rgba(255,255,255,0)"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(4 10)",
  fill: "#004460"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(13 10)",
  fill: "#004460"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3",
  "data-name": "Ellipse 3",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(22 10)",
  fill: "#004460"
});

var SvgElipsesNoBorder = function SvgElipsesNoBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "topic-details",
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElipsesNoBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/elipses-no-border.4dcbacc7.svg";
export { ForwardRef as ReactComponent };